import React from 'react';

const DiscountSettings = () => {
  return (
    <div>
      {' '}
      <div> This feature Discount Settings will be available soon.</div>
    </div>
  );
};

export default DiscountSettings;
